<template>
  <div class="main">
    <div class="title">
      救生员排班系统
    </div>
    <div class="login">
      <div class="logo">
        <van-icon name="friends-o" color="#1989fa" size="52" />
      </div>
      <van-field :border="false" v-model="tel" type="tel" clearable placeholder="请输入手机号" />
      <van-field :border="false" v-model="sms" center clearable placeholder="请输入短信验证码">
        <template #button>
          <van-button :disabled="!!sec" size="mini" round @click="getCode">
            <span style="padding: 0 4px;">{{ sec ? sec + 's' : '获取验证码' }}</span>
          </van-button>
        </template>
      </van-field>
      <van-button :type="is_login ? 'info' : 'primary'" round block @click="login">{{ is_login ? '登录' : '注册裁判员' }}</van-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import api from '@/api'
import { HOME_PAGE } from '@/store/mutation-types'

let timer = null

function scroll() {
  window.scrollTo(0, 0)
}

export default {
  beforeRouteEnter(to, from, next) {
    let token = localStorage.getItem('stToken')
    if (token) {
      next(HOME_PAGE)
    } else {
      next()
    }
  },
  mounted() {
    window.addEventListener('focusout', scroll)
  },
  data() {
    return {
      sec: 0,
      sms: '',
      tel: '',
      checked: '',
      is_login: true,
    }
  },
  methods: {
    ...mapActions(['Login']),
    getCode() {
      let reg = /^[1][0-9]{10}$/
      if (!this.tel) {
        this.$notify('请输入手机号码。')
        return
      } else if (!reg.test(this.tel)) {
        this.$notify('手机号码格式有误。')
        return
      }
      this.sec = 60

      api.common.smsCode({ phone: this.tel }).then((r) => {
        if (r.status * 1 === 200) {
          this.$notify({ type: 'success', message: '发送成功！' })
          timer = setInterval(() => {
            this.sec--
            if (this.sec === 0) clearInterval(timer)
          }, 1000)
        } else {
          this.$dialog
            .alert({
              title: '提示',
              message: r.message,
            })
            .then(() => {
              this.sec = 0
            })
        }
      })
    },
    login() {
      if (!this.tel) {
        this.$notify('请输入手机号码。')
        return
      } else if (!this.sms) {
        this.$notify('请输入验证码。')
        return
      }
      this.Login({ mobile: this.tel, code: this.sms }).then((r) => {
        if (r.code * 1 === 200) {
          this.$nextTick(() => {
            this.$router.replace({ path: HOME_PAGE })
          })
        } else {
          this.$dialog.alert({
            title: '提示',
            message: r.message,
          })
        }
      })
    },
  },
  beforeDestroy() {
    window.removeEventListener('focusout', scroll)
  },
}
</script>

<style lang="less" scoped>
.main {
  // background: url(../assets/bg.png) no-repeat top center/cover;
  height: 100vh;
  .title {
    font-size: 24px;
    text-align: center;
    padding: 60px 0;
    color: #ffffff;
    text-shadow: 0px 0px 2px #418cfc;
  }
  .van-cell {
    background: #daedff;
    border-radius: 25px;
    margin: 20px 0;
  }
  .agreement {
    margin: 10px auto;
  }
  .login {
    box-sizing: border-box;
    margin: 0 15px;
    padding: 80px 30px 80px;
    width: 345px;
    height: 373px;
    // background: url(../assets/login/login-card.png) no-repeat center center/contain;
    position: relative;
    .logo {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      width: 87px;
      height: 87px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .register {
      padding: 20px 0;
      display: block;
      text-align: center;
      color: #1989fa;
      font-size: 14px;
    }
  }
}
</style>
